"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1722],{

/***/ 12227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ CloneAPIModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(69396);
/* harmony import */ var _autodisco_src_nemo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _autodisco_src_nemo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_autodisco_src_nemo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81043);
/* harmony import */ var _redux_user_userSelectors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74918);
/* harmony import */ var _components_formComponents__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10005);
/* harmony import */ var _components_Loader_Loader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5786);
/* harmony import */ var _components_MessageBox_MessageBox__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43454);
/* harmony import */ var _components_buttons_Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57);
/* harmony import */ var _utils_serializeError__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(99584);
/* harmony import */ var _api_userApi__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62725);
/* harmony import */ var _utils_formAttribution__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(64357);
/* harmony import */ var _constants_linksConstants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71571);
/* harmony import */ var _components_Modal_Modal__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69581);
/* harmony import */ var _api_productsCatalogApi__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(43420);
/* harmony import */ var _api_settingsApi__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(83956);
/* harmony import */ var _utils_string__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(46553);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(2777);
/* harmony import */ var _config_userTracking__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(67474);
/* harmony import */ var _api_apiTemplatesCatalogApi__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(76014);
/* harmony import */ var _api_operationalDashboardApi__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(70013);
/* harmony import */ var _redux_useCases_allUseCasesSlice__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(95169);
/* harmony import */ var _redux_useCases_evaluationUseCasesSlice__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(87380);
/* harmony import */ var _redux_useCases_productionUseCasesSlice__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(90385);
/* harmony import */ var _redux_useCases_createdUseCasesSlice__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(14691);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _layout_Navigation_utils__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(91313);































var sendAnalyticsData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(_autodisco_src_nemo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(userData) {
        var dataToSend;
        return _autodisco_src_nemo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    dataToSend = {
                        type: "Platform API Creation",
                        formValues: (0,_utils_formAttribution__WEBPACK_IMPORTED_MODULE_23__/* .formAttribution */ .e)("Platform API Creation")
                    };
                    dataToSend.formValues.email = userData.user.email;
                    dataToSend.formValues.full_name = userData.user.name;
                    dataToSend.formValues.company = userData.organization.name;
                    _ctx.next = 7;
                    return _api_userApi__WEBPACK_IMPORTED_MODULE_9__/* .userApi.sendFrontForm */ .B.sendFrontForm(dataToSend);
                case 7:
                    _ctx.next = 12;
                    break;
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log("Failed to send analytics data");
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                9
            ]
        ]);
    }));
    return function sendAnalyticsData(userData) {
        return _ref.apply(this, arguments);
    };
}();
var CloneAPIModal = function(param) {
    var open = param.open, closeModal = param.closeModal, id = param.id, name = param.name, description = param.description, _variant = param.variant, variant = _variant === void 0 ? "FROM_TEMPLATES_CATALOG" : _variant, connectors = param.connectors;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_21__.useRouter)();
    var userData = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(_redux_user_userSelectors__WEBPACK_IMPORTED_MODULE_4__/* .userSelectors.getUserData */ .p.getUserData);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isLoading = ref[0], setIsLoading = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), error = ref1[0], setError = ref1[1];
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var handleSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(_autodisco_src_nemo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(event) {
            var ref, ref1, ref2, regionsList, ref3, regionId, response, useCaseId, data, newChannel, channelId, newChannelData;
            return _autodisco_src_nemo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        event.preventDefault();
                        _ctx.prev = 1;
                        ;
                        setError(null);
                        setIsLoading(true);
                        _ctx.next = 7;
                        return _api_settingsApi__WEBPACK_IMPORTED_MODULE_13__/* .settingsApi.getOrganizationRegions */ .p.getOrganizationRegions();
                    case 7:
                        ref2 = _ctx.sent;
                        regionsList = ref2.data;
                        ;
                        regionId = (ref3 = regionsList === null || regionsList === void 0 ? void 0 : (ref = regionsList[0]) === null || ref === void 0 ? void 0 : ref.id) !== null && ref3 !== void 0 ? ref3 : 1;
                        ;
                        _ctx.t0 = variant;
                        _ctx.next = _ctx.t0 === "FROM_TEMPLATES_CATALOG" ? 15 : _ctx.t0 === "FROM_DATASETS_CATALOG" ? 19 : _ctx.t0 === "FROM_CREATE_DATA_API" ? 23 : 39;
                        break;
                    case 15:
                        _ctx.next = 17;
                        return _api_apiTemplatesCatalogApi__WEBPACK_IMPORTED_MODULE_15__/* .apiTemplatesCatalogApi.cloneAPITemplate */ .k.cloneAPITemplate({
                            apiTemplateId: id,
                            name: name,
                            regionId: regionId,
                            description: description
                        });
                    case 17:
                        response = _ctx.sent;
                        return _ctx.abrupt("break", 39);
                    case 19:
                        _ctx.next = 21;
                        return _api_productsCatalogApi__WEBPACK_IMPORTED_MODULE_12__/* .productsCatalogApi.createApiFromProvider */ .r.createApiFromProvider({
                            providerId: id,
                            name: name,
                            regionId: regionId,
                            description: description
                        });
                    case 21:
                        response = _ctx.sent;
                        return _ctx.abrupt("break", 39);
                    case 23:
                        _ctx.next = 25;
                        return _api_apiTemplatesCatalogApi__WEBPACK_IMPORTED_MODULE_15__/* .apiTemplatesCatalogApi.cloneAPITemplate */ .k.cloneAPITemplate({
                            apiTemplateId: id,
                            name: name === "" ? "New Data API" : name,
                            regionId: regionId,
                            description: description === "" ? description : "Default Data API description..."
                        });
                    case 25:
                        response = _ctx.sent;
                        useCaseId = response.data.success.ops_dash_use_case_id;
                        _ctx.next = 29;
                        return _api_operationalDashboardApi__WEBPACK_IMPORTED_MODULE_16__/* .operationalDashboardApi.getUseCase */ .w.getUseCase(useCaseId);
                    case 29:
                        data = _ctx.sent.data;
                        newChannel = data.channels[0];
                        channelId = newChannel.id;
                        newChannelData = JSON.parse(JSON.stringify(newChannel));
                        connectors.forEach(function(connector) {
                            var connectorName = connector.name;
                            var connectorToAdd = (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)({}, connectorName, {
                                version: "$latest"
                            });
                            var newProviders = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)({}, newChannelData.configuration.providers, connectorToAdd);
                            newChannelData.configuration.providers = newProviders;
                        });
                        _ctx.next = 36;
                        return _api_operationalDashboardApi__WEBPACK_IMPORTED_MODULE_16__/* .operationalDashboardApi.updateUseCase */ .w.updateUseCase(useCaseId, {
                            ops_dash_use_case: {
                                description: description || "Default Data API description..."
                            }
                        });
                    case 36:
                        _ctx.next = 38;
                        return _api_operationalDashboardApi__WEBPACK_IMPORTED_MODULE_16__/* .operationalDashboardApi.updateChannel */ .w.updateChannel(channelId, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)({}, newChannel), {
                            configuration: newChannelData.configuration
                        }));
                    case 38:
                        return _ctx.abrupt("break", 39);
                    case 39:
                        sendAnalyticsData(userData, variant);
                        (0,_config_userTracking__WEBPACK_IMPORTED_MODULE_14__/* .sendGaEvent */ .k8)({
                            action: "Create Data API from ".concat(variant === "FROM_DATASETS_CATALOG" ? "Connector" : "Recipe", ' "').concat(name, '"'),
                            category: "Create Data API"
                        }, userData === null || userData === void 0 ? void 0 : (ref1 = userData.user) === null || ref1 === void 0 ? void 0 : ref1.email);
                        dispatch(_redux_useCases_allUseCasesSlice__WEBPACK_IMPORTED_MODULE_17__/* .allUseCasesThunks.fetchAllUseCases */ .v0.fetchAllUseCases({
                            forceFetch: true
                        }));
                        dispatch(_redux_useCases_evaluationUseCasesSlice__WEBPACK_IMPORTED_MODULE_18__/* .evaluationUseCasesThunks.fetchEvaluationUseCases */ .a7.fetchEvaluationUseCases({
                            forceFetch: true
                        }));
                        dispatch(_redux_useCases_productionUseCasesSlice__WEBPACK_IMPORTED_MODULE_19__/* .productionUseCasesThunks.fetchProductionUseCases */ .RZ.fetchProductionUseCases({
                            forceFetch: true
                        }));
                        dispatch(_redux_useCases_createdUseCasesSlice__WEBPACK_IMPORTED_MODULE_20__/* .createdUseCasesThunks.fetchCreatedUseCases */ .MV.fetchCreatedUseCases({
                            forceFetch: true
                        }));
                        router.push({
                            pathname: (0,_layout_Navigation_utils__WEBPACK_IMPORTED_MODULE_27__/* .generatePath */ .G)(_constants_linksConstants__WEBPACK_IMPORTED_MODULE_10__/* .linksConstants.USE_CASE_OVERVIEW */ .s.USE_CASE_OVERVIEW, {
                                useCaseId: response.data.success.ops_dash_use_case_id
                            }),
                            state: {
                                origin: "clone_api"
                            }
                        });
                        _ctx.next = 51;
                        break;
                    case 48:
                        _ctx.prev = 48;
                        _ctx.t1 = _ctx["catch"](1);
                        setError(getResponseErrors(_ctx.t1));
                    case 51:
                        _ctx.prev = 51;
                        setIsLoading(false);
                        return _ctx.finish(51);
                    case 54:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    48,
                    51,
                    54
                ]
            ]);
        }));
        return function handleSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var getResponseErrors = function(e) {
        var options = {
            returnFullDataObject: true,
            includeSourceError: false
        };
        var msg = (0,_utils_serializeError__WEBPACK_IMPORTED_MODULE_28__/* .serializeError */ .X)(e, options).message;
        if ((0,_utils_serializeError__WEBPACK_IMPORTED_MODULE_28__/* .serializeError */ .X)(e, options).status === 400) {
            return [
                msg.error
            ];
        }
        if (msg.length !== 0 && (0,_utils_serializeError__WEBPACK_IMPORTED_MODULE_28__/* .serializeError */ .X)(e, options).status === 422) {
            var errorCategories = Object.keys(msg);
            var errorArray = [];
            errorCategories.forEach(function(category) {
                var categoryNameCapitalized = (0,_utils_string__WEBPACK_IMPORTED_MODULE_29__/* .capitalize */ .kC)(category);
                var errorSubjects = Object.keys(msg[category].errors);
                errorSubjects.forEach(function(subject) {
                    var errorMessage = msg[category].errors[subject];
                    errorArray.push("".concat(categoryNameCapitalized, " ").concat(subject, " ").concat(errorMessage));
                });
            });
            return errorArray;
        } else {
            return null;
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Modal_Modal__WEBPACK_IMPORTED_MODULE_11__/* .Modal */ .u, {
        open: open,
        onBackdropClick: closeModal,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "CloneAPIModal__modal",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_buttons_Button__WEBPACK_IMPORTED_MODULE_8__/* .Button */ .z, {
                    onClick: closeModal,
                    variant: "noBorder",
                    className: "CloneAPIModal__modal__closeButton",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_30__/* .FiArrowLeft */ .Ao2, {}),
                        "Back"
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                    className: "CloneAPIModal__modal__header",
                    children: "Create Data API"
                }),
                variant === "FROM_CREATE_DATA_API" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                    className: "CloneAPIModal__modal__paragraph",
                    children: "Please agree to the following in order to add this connector to a new evaluation Data API and start running transactions."
                }),
                variant !== "FROM_CREATE_DATA_API" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                    className: "CloneAPIModal__modal__paragraph",
                    children: [
                        "Please agree to the following in order to clone this",
                        " ",
                        variant === "FROM_TEMPLATES_CATALOG" ? "recipe" : "dataset",
                        " to a new evaluation Data API and start running transactions."
                    ]
                }),
                isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "CloneAPIModal__loading",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Loader_Loader__WEBPACK_IMPORTED_MODULE_6__/* .Loader */ .a, {})
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                    onSubmit: handleSubmit,
                    className: "CloneAPIModal__form",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "CloneAPIModal__form__checkboxWrapper",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_formComponents__WEBPACK_IMPORTED_MODULE_5__/* .Checkbox */ .XZ, {
                                id: "agree",
                                label: "I agree that I will use this Data API for evaluation purposes only, and will not deploy this data API into a production environment.",
                                required: true
                            })
                        }),
                        error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "CloneAPIModal__form__error",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_MessageBox_MessageBox__WEBPACK_IMPORTED_MODULE_7__/* .MessageBox */ ._, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
                                    children: error.map(function(errorItem) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                            children: errorItem
                                        }, errorItem);
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "CloneAPIModal__form__actions",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_buttons_Button__WEBPACK_IMPORTED_MODULE_8__/* .Button */ .z, {
                                type: "submit",
                                children: "Create Evaluation API"
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 33076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Field; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(70714);
;// CONCATENATED MODULE: ./node_modules/@demystdata/ui/field/index.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 8px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  padding: 0;\n  color: ",
        ";\n  font-weight: 600;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 3px;\n  font-size: 12px;\n  color: var(--coolGray-400);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > * {\n    width: 100%;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  color: var(--coolGray-500);\n  font-size: 14px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n  max-width: 400px;\n  margin: 0;\n  padding: 0;\n  border: 0;\n\n  &:focus-within {\n    ",
        " {\n      color: var(--blue-900);\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var shouldForwardProp = function(prop) {
    return ![].includes(prop);
};
var LabelWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b6549ecd-0"
})(_templateObject());
var Label = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-b6549ecd-1"
})(_templateObject1(), function(props) {
    if (props.disabled) {
        return "var(--coolGray-400) !important";
    }
    if (props.invalid) {
        return "var(--pink-900) !important";
    }
    return "var(--coolGray-600)";
});
var Optional = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-b6549ecd-2"
})(_templateObject2());
var ElementWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b6549ecd-3"
})(_templateObject3());
var Hint = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-b6549ecd-4"
})(_templateObject4());
var Wrapper = (0,styled_components_browser_esm/* default */.ZP)("div").withConfig({
    shouldForwardProp: shouldForwardProp
}).withConfig({
    componentId: "sc-b6549ecd-5"
})(_templateObject5(), Label);

;// CONCATENATED MODULE: ./node_modules/@demystdata/ui/field/index.jsx




function Field(param) {
    var children = param.children, className = param.className, disabled = param.disabled, hideOptional = param.hideOptional, hint = param.hint, id = param.id, label = param.label, required = param.required, type = param.type;
    var ref = (0,react.useState)(false), invalid = ref[0], setInvalid = ref[1];
    var child = react.Children.only(children);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        className: className,
        type: type,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LabelWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                        disabled: disabled,
                        htmlFor: id,
                        invalid: invalid,
                        children: label
                    }),
                    required || hideOptional ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(Optional, {
                        children: "Optional"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ElementWrapper, {
                children: /*#__PURE__*/ (0,react.cloneElement)(child, {
                    onInvalid: function(event) {
                        if (child.props.onInvalid) {
                            child.props.onInvalid(event);
                        }
                        setInvalid(true);
                    },
                    onInput: function(event) {
                        if (child.props.onInput) {
                            child.props.onInput(event);
                        }
                        setInvalid(false);
                    }
                })
            }),
            hint ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Hint, {
                children: hint
            }) : null
        ]
    });
};
Field.propTypes = {
    children: (prop_types_default()).node.isRequired,
    className: (prop_types_default()).string,
    disabled: (prop_types_default()).bool,
    hideOptional: (prop_types_default()).bool,
    hint: (prop_types_default()).node,
    id: (prop_types_default()).string,
    label: (prop_types_default()).node.isRequired,
    required: (prop_types_default()).bool,
    type: (prop_types_default()).string
};


/***/ }),

/***/ 58733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TextareaField; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@reach/auto-id/dist/reach-auto-id.esm.js
var reach_auto_id_esm = __webpack_require__(765);
// EXTERNAL MODULE: ./node_modules/@demystdata/ui/field/index.jsx + 1 modules
var field = __webpack_require__(33076);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(70714);
// EXTERNAL MODULE: ./node_modules/@demystdata/ui/input/index.styles.js + 1 modules
var index_styles = __webpack_require__(56455);
;// CONCATENATED MODULE: ./node_modules/@demystdata/ui/textarea/index.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  line-height: 1.2;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Textarea = styled_components_browser_esm/* default.textarea.withConfig */.ZP.textarea.withConfig({
    componentId: "sc-20bec303-0"
})(_templateObject(), index_styles/* inputStyles */.TL);

;// CONCATENATED MODULE: ./node_modules/@demystdata/ui/textarea/index.jsx







/**
 * Renders a textarea.
 */ function textarea_Textarea(_param) {
    var ariaLabel = _param.ariaLabel, className = _param.className, id = _param.id, onChange = _param.onChange, onInput = _param.onInput, onInvalid = _param.onInvalid, _rows = _param.rows, rows = _rows === void 0 ? 3 : _rows, _size = _param.size, size = _size === void 0 ? "regular" : _size, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "ariaLabel",
        "className",
        "id",
        "onChange",
        "onInput",
        "onInvalid",
        "rows",
        "size"
    ]);
    var ref = (0,react.useState)(false), invalid = ref[0], setInvalid = ref[1];
    var props = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        "aria-label": ariaLabel
    });
    if (onChange) {
        props.onChange = function(event) {
            var target = event.target;
            onChange(target.value, event);
        };
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styles/* Wrapper */.im, {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Textarea, (0,_object_spread/* default */.Z)({
            "data-invalid": invalid,
            id: id,
            onInvalid: function(event) {
                if (onInvalid) {
                    onInvalid(event);
                }
                setInvalid(true);
            },
            onInput: function(event) {
                if (onInput) {
                    onInput(event);
                }
                setInvalid(false);
            },
            rows: rows,
            size: size
        }, props))
    });
};
textarea_Textarea.propTypes = {
    /**
   * ARIA label.
   */ ariaLabel: (prop_types_default()).string,
    /**
   * Textarea class name.
   */ className: (prop_types_default()).string,
    /**
   * Default value. Use for uncontrolled textareas.
   */ defaultValue: (prop_types_default()).string,
    /**
   * Whether to disable the textarea.
   */ disabled: (prop_types_default()).bool,
    /**
   * Textarea ID. If not provided, ID will be automatically generated.
   */ id: (prop_types_default()).string,
    /**
   * Textarea name.
   */ name: (prop_types_default()).string.isRequired,
    /**
   * Function called on change. Will be called with two attributes: `value` and `event`.
   */ onChange: (prop_types_default()).func,
    /**
   * Function called on input. Will be called with one attribute: `event`.
   */ onInput: (prop_types_default()).func,
    /**
   * Function called on invalid. Will be called with one attribute: `event`.
   */ onInvalid: (prop_types_default()).func,
    /**
   * Textarea placeholder.
   */ placeholder: (prop_types_default()).string,
    /**
   * Whether the textarea should be required.
   */ required: (prop_types_default()).bool,
    /**
   * Number of rows to render.
   */ rows: (prop_types_default()).number,
    /**
   * Textarea size.
   */ size: prop_types_default().oneOf([
        "regular",
        "small"
    ]),
    /**
   * Value. Use for controlled textareas along with `onChange`.
   */ value: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./node_modules/@demystdata/ui/textarea_field/index.jsx







/**
 * Renders a textarea field.
 */ function TextareaField(_param) {
    var className = _param.className, hideOptional = _param.hideOptional, hint = _param.hint, id = _param.id, label = _param.label, _rows = _param.rows, rows = _rows === void 0 ? 3 : _rows, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "hideOptional",
        "hint",
        "id",
        "label",
        "rows"
    ]);
    var idWithDefault = (0,reach_auto_id_esm/* useId */.M)(id);
    var disabled = otherProps.disabled, required = otherProps.required, type = otherProps.type;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(field/* default */.Z, {
        className: className,
        disabled: disabled,
        hideOptional: hideOptional,
        hint: hint,
        id: idWithDefault,
        label: label,
        required: required,
        type: type,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(textarea_Textarea, (0,_object_spread/* default */.Z)({
            id: idWithDefault,
            rows: rows
        }, otherProps))
    });
};
TextareaField.propTypes = {
    /**
   * ARIA label.
   */ ariaLabel: (prop_types_default()).string,
    /**
   * Field class name.
   */ className: (prop_types_default()).string,
    /**
   * Default value. Use for uncontrolled textareas.
   */ defaultValue: (prop_types_default()).string,
    /**
   * Whether to disable the textarea.
   */ disabled: (prop_types_default()).bool,
    /**
   * Whether to hide "Optional" label despite field not being required.
   */ hideOptional: (prop_types_default()).bool,
    /**
   * Textarea hint. Displayed below the textarea.
   */ hint: (prop_types_default()).node,
    /**
   * Textarea ID. If not provided, ID will be automatically generated.
   */ id: (prop_types_default()).string,
    /**
   * Textarea label. Displayed above the textarea.
   */ label: (prop_types_default()).node,
    /**
   * Textarea name.
   */ name: (prop_types_default()).string.isRequired,
    /**
   * Function called on change. Will be called with two attributes: `value` and `event`.
   */ onChange: (prop_types_default()).func,
    /**
   * Textarea placeholder.
   */ placeholder: (prop_types_default()).string,
    /**
   * Whether the textarea should be required.
   */ required: (prop_types_default()).bool,
    /**
   * Number of rows to render.
   */ rows: (prop_types_default()).number,
    /**
   * Textarea size.
   */ size: prop_types_default().oneOf([
        "regular",
        "small"
    ]),
    /**
   * Value. Use for controlled textareas along with `onChange`.
   */ value: (prop_types_default()).string
};


/***/ })

}]);